/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ChargerStatusInterface {
  global: string;
  connectors: string;
  chargingPoints: string;
  defects: string;
  connectorStatus: string;
  electricity: string;
  deviceStatus: string;
  deviceDuration: string;
  deviceUtilization: string;
  chargingSchedules: string;
}

const initialState: ChargerStatusInterface = {
  global: 'personal',
  connectors: 'personal',
  chargingPoints: 'personal',
  defects: 'personal',
  connectorStatus: 'personal',
  electricity: 'personal',
  deviceStatus: 'personal',
  deviceDuration: 'personal',
  deviceUtilization: 'personal',
  chargingSchedules: 'personal',
};

export const chargerStatusSlice = createSlice({
  name: 'charger-status',
  initialState,
  reducers: {
    /**
     * Function to update global charger status
     * @param {any} state The current slice state.
     * @param {any} action The action payload containing the new charger status.
     */
    updateChargerType: (state, action: PayloadAction<string>) => {
      state.global = action.payload;
      state.connectors = action.payload;
      state.chargingPoints = action.payload;
      state.defects = action.payload;
      state.connectorStatus = action.payload;
      state.electricity = action.payload;
      state.deviceStatus = action.payload;
      state.deviceDuration = action.payload;
      state.deviceUtilization = action.payload;
      state.chargingSchedules = action.payload;
    },
  },
});

export const { updateChargerType } = chargerStatusSlice.actions;
export default chargerStatusSlice.reducer;
